import './ContentPartner.scss';
import { extractUrlFromAnchorTag } from '@helpers/parseContentHTML';

export default function ContentPartner({
  logoUrl,
  partnerName,
  imageUrl,
  title,
  subtitle,
  buttonUrl,
  buttonLabel
}) {
  return (
    <div className="contentPartner">
      <div className="contentPartner-header">
        {logoUrl && (
          <img
            src={extractUrlFromAnchorTag(logoUrl)}
            alt={`${partnerName} logo`}
            className="contentPartner-logo"
          />
        )}
        <span className="contentPartner-text">
          In samenwerking met {partnerName}
        </span>
      </div>
      <div className="contentPartner-body">
        <img
          src={extractUrlFromAnchorTag(imageUrl)}
          alt="Content image"
          className="contentPartner-img"
        />
        <div className="contentPartner-text-wrap">
          <h4 className="contentPartner-title">{title}</h4>
          <p
            className="contentPartner-subtitle"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          ></p>

          <a
            href={extractUrlFromAnchorTag(buttonUrl)}
            className="contentPartner-btn"
            rel="noopener noreferrer"
            target="_blank"
          >
            {buttonLabel}
          </a>
        </div>
      </div>
    </div>
  );
}
